// routes/VehiculosRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import BuscarVehiculoPage from "../pages/BuscarVehiculoPage";

const VehiculosRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<BuscarVehiculoPage />} />
      {/* Si en el futuro quieres más rutas, aquí las agregas */}
    </Routes>
  );
};

export default VehiculosRoutes;
